<template>
    <div :class="css.modal" v-if="show">
        <ui-icon :class="css.close" name="close" @click="methods.close" />

        <div :class="css.main" :style="style.main">
            <div :class="css.steps">
                <div :class="css.header">
                    <div class="text-[16px] leading-[32px] font-bold color-1">{{ vars.steps[step - 1].step }}</div>
                    <div>({{ step }}/3)</div>
                </div>
                <div :class="css.contexts">
                    <p v-for="(context, key) in vars.steps[step - 1].contents" v-html="context" :key="key"></p>
                </div>

                <div :class="css.buttons" class="flex-center">
                    <div :class="css.button" @click="change('prev')" v-show="step > 1">{{ $t("Prev") }}</div>
                    <div :class="css.button" @click="methods.close" v-if="step == 3">{{ $t("Close") }}</div>
                    <div :class="css.button" @click="change('next')" v-else>{{ $t("Next") }}</div>
                </div>
                <div :class="css.line"></div>
            </div>
            <div :class="css.images">
                <img :class="css[`image${step}`]" :src="vars.steps[step - 1].image" />
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
//* 组件库
import { UiIcon } from "various-ui";
//* 组件属性
import { TutorialPropsOption } from "./index";
import { useComposable } from "./src/composable";
//* 样式
import css from "./style/index.module.less";

//* 注册组件属性
const define = defineProps(TutorialPropsOption);

//* 组合函数
const { refs, vars, methods, style } = useComposable(define);
const { show, step } = refs;
const { change } = methods;

//* 组件挂载时, 注册观察者
onMounted(() => {
    vars.observer.value?.disconnect();
    vars.observer.value = new ResizeObserver(() => methods.render());

    document.body && vars.observer.value.observe(document.body);
});

//* 组件卸载时, 注销观察者
onBeforeUnmount(() => {
    vars.observer.value?.disconnect();
});

//* 组件属性导出
defineExpose({ open: methods.open });
</script>
